export const CLINICAL_ADMIN = 1;

export const SUPER_ADMIN = 3;

/** Every role that signs in to this panel: clinicians (1) and super admins (3). Patients are role 2. */
export const STAFF_ROLES = [CLINICAL_ADMIN, SUPER_ADMIN];

/** Whether this role is a staff role (clinician or super admin) - never true for a patient or anything else. */
export function isStaffRole(role) {
    return STAFF_ROLES.includes(role);
}
